import { AppNS } from 'app';
import { useUiStore } from 'app/core/store_v2/ui';

import { Box, SxProps, Theme, useTheme } from '@mui/material';

import LogoutButton from './LogoutButton';
import NavigationElement from './NavigationElement';

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(5),
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '100%',
      '& .settingsPanel': {
        position: 'relative',
        borderTop: `1px solid ${theme.palette.divider}`,
        // overflowX: 'hidden',
        '&:before': {
          position: 'absolute',
          top: 0,
          left: 0,
          content: '""',
          display: 'block',
          width: `calc(100% - ${theme.spacing(3)}px)`,
          height: 1,
          background: theme.palette.divider,
        },
      },
    },
  };
};

interface NavigationProps {
  navigation: AppNS.NavigationElement[];
}
export default function Navigation(props: NavigationProps) {
  const { navigation } = props;
  const { sidebarState } = useUiStore();
  const theme = useTheme();
  const styles = getStyles(theme);

  const settings = navigation.filter((item: AppNS.NavigationElement) => {
    return item.show && item.settings;
  });

  const nav = navigation.filter((item: AppNS.NavigationElement) => {
    return item.show && !item.settings;
  });

  return (
    <Box sx={styles.root}>
      {nav.map((item: AppNS.NavigationElement) => (
        <Box key={item.id} sx={{ marginBottom: '2px' }}>
          <NavigationElement element={item} sidebarState={sidebarState} />
        </Box>
      ))}

      <Box sx={{ flex: 1 }}></Box>

      <div className="settingsPanel">
        {settings.map((item: AppNS.NavigationElement) => (
          <Box key={item.id} sx={{ marginBottom: '2px' }}>
            <NavigationElement element={item} key={item.id} sidebarState={sidebarState} />
          </Box>
        ))}
        <LogoutButton sidebarState={sidebarState} />
      </div>
    </Box>
  );
}
